module.exports = "<div class=\"alert alert-{{$ctrl.alertType}} fade in closing\" ng-class=\"{ 'full-width': $ctrl.fullWidth}\" role=alert ng-show=$ctrl.isShowing> <i class=\"td-icon icon-{{$ctrl.icon}}\" ng-if=$ctrl.icon></i> <button type=button class=close aria-label=close ng-click=$ctrl.closeAlert()></button> <p ng-bind-html=$ctrl.alertMessage></p> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/alert/alert.html
// module id = 609
// module chunks = 0